app.controller("EmployeeReviewedDocumentsController", [
    "$scope", "$stateParams", "StaticData", "DocumentsService", "AuthService", "$uibModal", "Socket", "$state", "toastr", "usSpinnerService", "InfoModal", "$httpParamSerializer",
    function ($scope, $stateParams, StaticData, DocumentsService, AuthService, $uibModal, Socket, $state, toastr, usSpinnerService, InfoModal, $httpParamSerializer) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = $stateParams.limit || 10;
        $scope.format = "dd-MM-yyyy";
        $scope.query = $stateParams.query || null;
        $scope.type = $stateParams.type || null;
        $scope.documentState = $stateParams.documentState || null;
        $scope.chancelleryStatus = $stateParams.chancelleryStatus || null;
        $scope.addressee = $stateParams.addressee || null;
        $scope.author = $stateParams.author || null;
        $scope.chancelleryWorker = $stateParams.chancelleryWorker || null;
        $scope.uniqueNumber = $stateParams.uniqueNumber || null;
        $scope.fromDate = $stateParams.fromDate ? new Date($stateParams.fromDate) : null;
        $scope.toDate = $stateParams.toDate ? new Date($stateParams.toDate) : null;
        $scope.documentTypes = {
            'INNER': [],
            'STUDENT_INNER': [],
            'OUTER': [],
            'OUTGOING': [],
            'OTHER': [],
        };

        $scope.chancelleryStates = [
            { _id: 'returned', name: 'მობრუნებული' },
            { _id: 'approved', name: 'დაშვებული' }
        ];

        $scope.documentStates = [
            { _id: true, name: 'შესრულებული' },
            { _id: false, name: 'შეუსრულებელი' }
        ];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.fromDateOptions = {
            maxDate: new Date()
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        $scope.getAuthor = function (doc) {
            if (doc && doc.author && !doc.senderType) return doc.author.user.firstName + " " + doc.author.user.lastName;
            if (doc.senders) return doc.senders.map(function (sender) { return sender.name }).toString();
            else return null;
        }
        if ($stateParams.addressee) {
            DocumentsService.fetchEmployee($stateParams.addressee).then(function (emp) {
                $scope.addressee = emp;
                $scope.addressee.positionInfo = {};
                $scope.addressee.positionInfo.organization = emp.organization;
                $scope.addressee.positionInfo.position = emp.position;
            });
        }

        if ($stateParams.author) {
            usSpinnerService.spin("root");
            DocumentsService.fetchEmployee($stateParams.author).then(function (emp) {
                $scope.author = {
                    _id: emp.profile,
                    user: emp.user,
                    positionInfo: {
                        position: emp.position,
                        organization: emp.organization
                    }
                };
                usSpinnerService.stop("root");
            });
        }

        if ($stateParams.chancelleryWorker) {
            usSpinnerService.spin("root");
            DocumentsService.fetchEmployee($stateParams.chancelleryWorker).then(function (emp) {
                $scope.chancelleryWorker = {
                    _id: emp.profile,
                    user: emp.user,
                    positionInfo: {
                        position: emp.position,
                        organization: emp.organization
                    }
                };
                usSpinnerService.stop("root");
            });
        }

        $scope.getEmployees = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: query
            }).then(function (data) {
                return data.docs;
            });
        };

        var socket = new Socket("/documents");

        socket.on('reviewed', function (document) {
            $scope.documents.unshift(document);
            $scope.totalItems = $scope.documents.length;
        });

        StaticData.getItemsByKey("document_types").then(function (types) {
            $scope.documentTypesMap = _.keyBy(types, '_id');
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            data.forEach(function (type) {
                if (!type.isForStudent) {
                    $scope.documentTypes[type.parentId].push(type)
                }
            });
            $scope.type = $stateParams.type || null;
        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.applyFilter = function () {
            $state.go(".", {
                page: $scope.currentPage,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                type: $scope.type,
                chancelleryStatus: $scope.chancelleryStatus,
                documentState: $scope.documentState,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author._id ? $scope.author._id : $scope.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $scope.addressee,
                chancelleryWorker: $scope.chancelleryWorker && $scope.chancelleryWorker._id ? $scope.chancelleryWorker._id : $scope.chancelleryWorker
            });
        };

        loadPage($stateParams.page).then(function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page) {
            usSpinnerService.spin("root");
            return DocumentsService.reviewedList({
                page: page,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                type: $scope.type,
                chancelleryStatus: $scope.chancelleryStatus,
                documentState: $scope.documentState,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author._id ? $scope.author._id : $scope.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $scope.addressee
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.totalItems = res.data.total;
                $scope.itemsPerPage = res.data.limit;
                usSpinnerService.stop("root");
            });
        }

        $scope.exportReviewed = function() {
            var qs = $httpParamSerializer({
                query: $scope.query,
                type: $scope.type,
                chancelleryStatus: $scope.chancelleryStatus,
                documentState: $scope.documentState,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author._id ? $scope.author._id : $scope.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $scope.addressee
            });
            window.open('/documents/reviewed/export?' + qs);
        };

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.open = function (actionType, docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { actionType: actionType, documentId: docId, returnUrl: window.location.href })
        };

        $scope.addComment = function (doc, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: null,
                            action: 'create',
                            comment: doc.chancelleryComment
                        };
                    }
                }
            }).result.then((data) => {
                usSpinnerService.spin("root");
                DocumentsService.addComment(doc._id, data.comment).then(function () {
                    usSpinnerService.stop("root");
                    toastr.success('', 'კომენტარი შენახულია');
                }).catch(function () {
                    usSpinnerService.stop("root");
                    toastr.error('', 'დაფიქსირდა შეცდომა');
                });
            }).catch((err) => {
                if (err) {
                    toastr.error('', 'დაფიქსირდა შეცდომა');
                }
            })
        };

        $scope.showComment = function (comment, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment: comment,
                            action: 'view',
                            header: 'კანცელარიის'
                        };
                    }
                }
            })
        };

        $scope.generateState = function (doc) {
            if (doc.deadline && doc.status !== 'done') {
            }
            return doc.deadline && doc.status !== 'done' && (new Date(doc.deadline) < new Date());
        };

        $scope.generateTooltip = function (document) {
            if (document.chancelleryStatus === 'returned') {
                return 'მობრუნებულია კანცელარიის მიერ';
            } else if (document.status && document.status === "done") {
                return 'შესრულებული';
            } else {
                return 'მიმდინარე'
            }
        };

        $scope.generateClass = function (document) {
            if (document.chancelleryStatus === 'returned') {
                return 'doc-returned';
                // if (!status || status == 'unread') return 'doc-unread';
                // if (status == 'approved') return 'doc-approved';
                // if (status == 'read') return 'doc-read';
                // if (status == 'returned') return 'doc-returned';

            } else if (document.status && document.status === "done") {
                return 'doc-done';
            } else {
                return 'doc-read'
            }

        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.menu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.finalizeSelected = function () {
            var selected = $scope.documents.filter(function (el) {
                return el.checked === true;
            });
            if (selected.length < 1) {
                InfoModal.show({ title: "ინფორმაცია", message: "გთხოვთ მონიშნოთ მინიმუმ ერთი დოკუმენტი" });
                return;
            }
            $scope.finalizeMany(selected);
        };

        $scope.finalizeMany = function (documents, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "FinalizeReviewedModalController",
                templateUrl: _pb + 'employee/documents/finalize-reviewed-modal.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            documents: documents
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page).then(function () {
                        $scope.currentPage = $stateParams.page;
                    });
                }, function () {
                });
        };

        $scope.finalize = function (document, $event) {
            $scope.finalizeMany([document], $event);
        };

        $scope.none = function ($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
        };

        $scope.share = function (documentId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EmployeeShareDocumentController",
                templateUrl: _pb + 'employee/documents/employee-share-document.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            documentId: documentId
                        };
                    }
                }
            });
        };

        $scope.selectAll = function () {
            angular.forEach($scope.documents, function (el) {
                if (el.status === 'done' && !el.finalDate) {
                    el.checked = true;
                }
            });
        };

        $scope.selectNone = function () {
            angular.forEach($scope.documents, function (el) {
                el.checked = false;
            });
        };

        $scope.add = function () {
            $state.go('employee.documents.new-internal');
        };
    }
]);
